import { ReactElement } from 'react';

import { toAbsoluteUrl } from '~utils/assetsHelpers';

import { GlobalBannersCommonsProps } from '../types';
import GlobalBannersModalBase from '../ModalBase';
import {
  GlobalBannersContentBase,
  GlobalBannersImgBase,
  GlobalBannersIconButtonBase,
} from '../styles';

const GlobalBannersFreePremiunFor30Days = ({
  open,
  onClose,
}: GlobalBannersCommonsProps): ReactElement => (
  <GlobalBannersModalBase open={open} onClose={onClose}>
    <GlobalBannersContentBase sx={{ maxWidth: 417, maxHeight: 598 }}>
      <GlobalBannersIconButtonBase
        onClick={onClose}
        isWhite
        sx={{ right: 22, top: 35 }}
      >
        X
      </GlobalBannersIconButtonBase>

      <GlobalBannersImgBase
        src={toAbsoluteUrl(
          '/images/globalsBanners/free_premiun_for_30_days.png',
        )}
        alt="Free Premiun for 30 days"
      />
    </GlobalBannersContentBase>
  </GlobalBannersModalBase>
);

export default GlobalBannersFreePremiunFor30Days;
